<!--<owl-carousel-o  [options]="customOptions">-->
<!--&lt;!&ndash;    <ng-template *ngFor="let element of product; index as i" carouselSlide><img src="{{getImageURL(i)}}"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                                    class="img-fluid" alt="...">&ndash;&gt;-->
<!--    <ng-template *ngFor="let element of product.media_gallery_entries; index as i"  carouselSlide><img (click)="itemSelected()" src="{{getImageURL(i)}}" class="img-fluid " style="width: 100px;margin-left: 230px; margin-bottom: 20px" alt="...">-->
<!--    </ng-template>-->
<!--</owl-carousel-o>-->


<div class="container ">

    <div class="" style="" *ngFor="let element of product.media_gallery_entries; index as i">
        <div *ngIf="element.media_type == 'external-video'">
            <div>
                <div (click)="itemSelected()" (click)="openVideoDialog($event , i)" class="player_overlay">
                    <i (click)="itemSelected()" (click)="openVideoDialog($event , i)" class="fa fa-play-circle"></i>
                </div>
                <img (click)="itemSelected()" src="{{getImageURL(i)}}"  alt="..."
                     (click)="openVideoDialog($event , i)">
            </div>

        </div>

    </div>

    <div class="" style="" *ngFor="let element of product.media_gallery_entries; index as i">

        <div *ngIf="element.media_type == 'image'">
            <img (click)="itemSelected()" src="{{getImageURL(i)}}" class="img-fluid " alt="..."
                 (click)="openImageDialog($event , i)">
        </div>
    </div>

</div>

